export default __webpack_public_path__ + "static/media/portfolio5.27d3baf5.jpg";